import { useEffect, useState } from "react";
import {
  MODIFICATION_ID,
  PROJECT_ID,
  STACK_ID,
  VERSION_ID,
  COMPARATOR_PROJECT_ID,
  COMPARATOR_VERSION_ID,
  SOURCE_MODIFICATION_ID,
  SOURCE_PROJECT_ID,
} from "../const/routeParams";

const getSearchParamOrUndefined =
  (search: URLSearchParams) =>
  <T>(paramKey: string): T | undefined => {
    const rawParam = search.get(paramKey);
    if (rawParam === null) {
      return undefined;
    }
    const numberedParam = Number(rawParam);
    return Number.isNaN(numberedParam) ? (rawParam as T) : (numberedParam as T);
  };

export const useProjectParams = () => {
  const [modificationId, setModificationId] = useState<number | undefined>(undefined);
  const [stackId, setStackId] = useState<number | undefined>(undefined);
  const [versionId, setVersionId] = useState<string | undefined>(undefined);
  const [projectId, setProjectId] = useState<string | undefined>(undefined);
  const [comparatorVersionId, setComparatorVersionId] = useState<string | undefined>(undefined);
  const [comparatorProjectId, setComparatorProjectId] = useState<string | undefined>(undefined);
  const [sourceProjectId, setSourceProjectId] = useState<number | undefined>(undefined);
  const [sourceModificationId, setSourceModificationId] = useState<number | undefined>(undefined);

  useEffect(() => {
    const getParam = getSearchParamOrUndefined(new URLSearchParams(window.location.search));

    setModificationId(getParam<number>(MODIFICATION_ID));
    setStackId(getParam<number>(STACK_ID));
    setVersionId(getParam<string>(VERSION_ID));
    setProjectId(getParam<string>(PROJECT_ID));
    setComparatorVersionId(getParam<string>(COMPARATOR_VERSION_ID));
    setComparatorProjectId(getParam<string>(COMPARATOR_PROJECT_ID));

    setSourceModificationId(getParam<number>(SOURCE_MODIFICATION_ID));
    setSourceProjectId(getParam<number>(SOURCE_PROJECT_ID));
  });

  return {
    modificationId,
    stackId,
    projectId,
    versionId,
    comparatorProjectId,
    comparatorVersionId,
    sourceProjectId,
    sourceModificationId,
  };
};
